import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export const WhatsAppButton = () => {
  // Format phone number for WhatsApp URL (removing spaces and any special characters)
  const phoneNumber = '27677834937'; // This is the formatted version of + 27 677 834 937
  const whatsappUrl = `https://wa.me/${phoneNumber}`;
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 bg-red-600 text-white rounded-full shadow-lg hover:bg-red-700 transition-all duration-300 z-50 flex items-center group" data-id="element-281">
      <div className="flex items-center p-3 pr-5" data-id="element-282">
        <MessageCircleIcon className="h-6 w-6 mr-2" data-id="element-283" />
        <span className="font-medium" data-id="element-284">Let's Chat</span>
      </div>
      <div className="absolute right-full mr-3 bg-white text-gray-800 px-3 py-2 rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap" data-id="element-285">
        Chat with us on WhatsApp
      </div>
    </a>;
};